import type React from "react";

import {faEye, faTrophy} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useLevelV2} from "~/api/hooks/useLevelV2";

interface LevelStatsProps {
  /**
   * Level ID to load relevant data.
   */
  levelId?: string;
}

/**
 * Component to display level statistics including total views and success rate.
 */
const LevelStats: React.FC<LevelStatsProps> = ({levelId}) => {
  const {data: level, isLoading} = useLevelV2({id: levelId});

  if (isLoading) {
    return (
      <div className="flex justify-between items-center text-xs text-gray-400 mt-1">
        <span>Loading stats...</span>
      </div>
    );
  }

  if (!level) {
    return (
      <div className="flex justify-between items-center text-xs text-gray-400 mt-1">
        <span>No stats available</span>
      </div>
    );
  }

  return (
    <div className="flex justify-between items-center text-xs text-gray-300 mt-1">
      <div className="flex items-center">
        <FontAwesomeIcon icon={faEye} className="mr-1" />
        <span>{level.totalViews}</span>
      </div>
      <div className="flex items-center">
        <FontAwesomeIcon icon={faTrophy} className="mr-1" />
        <span>{Math.round(level.successRate * 100)}%</span>
      </div>
    </div>
  );
};

export default LevelStats;
